export const CheckOutTypeEnum = {
    REGULAR_ORDER: 'regular_order',
    INDIVIDUAL_ORDER: 'individual_order',
};
